import { render } from "./homeComp.vue?vue&type=template&id=d3362dc6&scoped=true"
import script from "./homeComp.vue?vue&type=script&lang=js"
export * from "./homeComp.vue?vue&type=script&lang=js"

import "./homeComp.vue?vue&type=style&index=0&id=d3362dc6&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3362dc6"]])

export default __exports__